import { lazy } from 'react';

const ConfirmSupportMail = lazy(() => import(/* webpackChunkName: "support" */ './confirm-support-mail.js'));

export default ConfirmSupportMail;
